import * as React from "react";
import { Button } from "../button/button.mjs";
class ProgressBar extends React.Component {
  BEM() {
    const classArray = ["progress-bar"];
    if (this.props.progress >= 75) {
      classArray.push("progress-bar--fill-high");
    } else if (this.props.progress >= 50) {
      classArray.push("progress-bar--fill-medium");
    } else {
      classArray.push("progress-bar--fill-low");
    }
    if (this.props.type) {
      classArray.push("progress-bar--type-order");
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  getOverlayStyle() {
    return {
      width: "".concat(this.props.progress, "%")
    };
  }
  getTitle() {
    return /* @__PURE__ */ React.createElement("div", { className: "progress-bar__title" }, this.props.title);
  }
  getButton(button) {
    return /* @__PURE__ */ React.createElement(Button, { ...button, size: "small", className: "progress-bar__button" });
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: this.BEM() }, this.props.title && this.getTitle(), /* @__PURE__ */ React.createElement("div", { className: "progress-bar__inner" }, /* @__PURE__ */ React.createElement("div", { className: "progress-bar__bar-wrapper" }, /* @__PURE__ */ React.createElement("div", { className: "progress-bar__bar progress-bar__bar--content" }, this.props.text), /* @__PURE__ */ React.createElement("div", { className: "progress-bar__bar progress-bar__bar--overlay", style: this.getOverlayStyle() }, this.props.text)), this.props.button && this.getButton(this.props.button)));
  }
}
export {
  ProgressBar
};
